// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/App/Static/Header/index.scss
// module id = 8277
// module chunks = 2